export function formatDateTime(value: string | null | undefined, locale: string, fallback: string): string {
  if (!value) return fallback
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(date)
}

export function formatDate(value: string | null | undefined, locale: string, fallback: string): string {
  if (!value) return fallback
  const date = new Date(`${value}T00:00:00Z`)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeZone: 'UTC' }).format(date)
}

export function numberLabel(value: number | null | undefined, locale: string): string {
  return (value ?? 0).toLocaleString(locale)
}

export function percentLabel(value: number | null | undefined, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(value ?? 0)
}

export function statusTone(status: string | null | undefined): 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand' | 'coral' {
  const normalized = (status ?? '').toUpperCase()
  if (['CONNECTED', 'OK', 'SUCCESS', 'SUCCEEDED', 'COMPLETED', 'ACTIVE'].includes(normalized)) return 'success'
  if (['DEGRADED', 'WARNING', 'QUEUED', 'RUNNING'].includes(normalized)) return 'warning'
  if (['DOWN', 'ERROR', 'FAILED', 'DISCONNECTED', 'AUTH_EXPIRED', 'EXCEEDED'].includes(normalized)) return 'danger'
  if (['ADMIN', 'OWNER'].includes(normalized)) return 'brand'
  return 'neutral'
}

export function severityTone(severity: string | null | undefined): 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand' | 'coral' {
  const normalized = (severity ?? '').toUpperCase()
  if (normalized === 'CRITICAL' || normalized === 'HIGH') return 'danger'
  if (normalized === 'MEDIUM' || normalized === 'WARNING') return 'warning'
  if (normalized === 'LOW') return 'info'
  return 'neutral'
}

export const tableContainerStyle = {
  overflowX: 'auto',
  border: '1px solid var(--border-subtle)',
  borderRadius: 16,
  background: 'var(--bg-card)',
} as const

export const thStyle = {
  padding: '11px 14px',
  background: 'var(--ink-50)',
  color: 'var(--fg-subtle)',
  fontSize: 11,
  fontWeight: 800,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  textAlign: 'start',
  whiteSpace: 'nowrap',
} as const

export const tdStyle = {
  padding: '13px 14px',
  borderTop: '1px solid var(--border-subtle)',
  color: 'var(--fg-muted)',
  fontSize: 13,
  verticalAlign: 'top',
} as const
